import React from "react";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import TickSection from "../../components/tickSection/TickSection";
import "./servicePage.css";
import GreenElementLight from "../../assets/logo-element-green-light.svg";
import BlueElementLight from "../../assets/logo-element-blue-light.svg";
import RedElementLight from "../../assets/logo-element-red-light.svg";
import BlackElementLight from "../../assets/logo-element-black-light.svg";
import Snowflake from "../../assets/snowflakeIcon_red.svg";
{/*import Spring500 from '../../assets/spring500.svg'*/}
import BookingForm from "../../components/bookingForm/BookingForm";
import { Helmet } from 'react-helmet-async';

const ServicePage: React.FC = () => {
    return (
        <div>
            <Helmet>
                <title>Skidservice - Vallning slipning och Reparationer - Alpine Sport</title>
                <meta name="description" content="Få den bästa skidservicen i Kristinehamn & Värmland med Alpine Sport. Vi tar hand om din utrustning med noggrann service och reparationer. Vallning, slipning och reparationer." />
                <meta property="og:title" content="Skidservice & Reparationer - Alpine Sport" />
                <meta property="og:description" content="Få den bästa skidservicen i Kristinehamn & Värmland med Alpine Sport. Vi tar hand om din utrustning med noggrann service och reparationer. Vallning, slipning och reparationer." />
                <meta property="og:image" content="%PUBLIC_URL%/socials-image.png" />
                <link rel="icon" href="%PUBLIC_URL%/colours-favicon.png" type="image/png" />
                <link rel='icon' href='%PUBLIC_URL%/colour-favicon.png' type='image/png' />
                <meta property="og:url" content="https://alpinesport.se/skidservice" />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://alpinesport.se/skidservice" />
            </Helmet>
            <Header />
            <main>
                <TickSection />
                <div className="service-container">
                    <section className="service-section service-leftSection">
                        <article>
                            <h1 className="service-h1">Servicenivåer & Priser</h1>
                            <p className="service-p">
                                Här är servicealternativen som Alpine Sport erbjuder. Vi tar emot både alpinutrustning och snowboards. För att boka service ta kontakt med oss genom att fylla ut frågeformuläret på denna sida så återkommer vi och bokar en tid. Är du osäker på vad som behöver göras, välj alternativet “bedömning” i frågeformuläret så tar vi en titt på din utrustning och gör en bedömning av vad som borde göras. Vi rekommenderar att utrustning som ska vallas lämnas med oss i några dagar så att vallan kan tränga in ordentligt i beläggen och hålla längre. Har du frågor, ta kontakt med oss.
                            </p>
                        </article>
                        <section className="serviceLevels-container">
                            <article className="serviceLevel-tile">
                                {/*<img className="logo-element-spring500" src={Spring500} alt="offer symbol" />*/}
                                <h3 className="service-h3">Sommar- konservering</h3>
                                <ul className="service-list">
                                    <li>Översyn av skidor & bindningar</li>
                                    <li>Rengöring</li>
                                    <li>Slipning av kanter</li>
                                    <li>Enklare lagning av belag</li>
                                    <li>Mättning av belag med mjukvalla</li>
                                    <li>Slutvallning</li>
                                    <li>Borstning & finish</li>
                                </ul>
                                {/*<p className="service-price offer-price">Erbjudande: 500 sek tom 30/4</p>*/}
                                <p className="service-price">Pris: 650 sek</p>
                            </article>
                            <article className="serviceLevel-tile">
                                <img className="logo-element" src={GreenElementLight} alt="" />
                                <h3 className="service-h3">Enkel</h3>
                                <ul className="service-list">
                                    <li>Rengöring</li>
                                    <li>Vallning</li>
                                    <li>Borstning av belägg</li>
                                </ul>
                                <p className="service-price">Pris alpint: 350 sek</p>
                                <p className="service-price">Pris snowboard: 400 sek</p>
                            </article>
                            <article className="serviceLevel-tile">
                                <img className="logo-element" src={BlueElementLight} alt="" />
                                <h3 className="service-h3">Avancerad</h3>
                                <ul className="service-list">
                                    <li>Rengöring</li>
                                    <li>Vallning</li>
                                    <li>Slipning av kanter</li>
                                    <li>Borstning av belägg</li>
                                </ul>
                                <p className="service-price">Pris alpint: 450 sek</p>
                                <p className="service-price">Pris snowboard: 500 sek</p>
                            </article>
                            <article className="serviceLevel-tile">
                                <img className="logo-element" src={RedElementLight} alt="" />
                                <h3 className="service-h3">Expert</h3>
                                <ul className="service-list">
                                    <li>Rengöring</li>
                                    <li>Vallning</li>
                                    <li>Slipning av kanter</li>
                                    <li>Finfinish med diamantslip</li>
                                    <li>Borstning av belägg</li>
                                </ul>
                                <p className="service-price">Pris alpint: 550 sek</p>
                                <p className="service-price">Pris snowboard: 600 sek</p>
                            </article>
                            <article className="serviceLevel-tile">
                                <img className="logo-element" src={BlackElementLight} alt="" />
                                <h3 className="service-h3">Fixa hål & repor</h3>
                                <p className="service-p">
                                    Hål och repor fylls med hjälp av en maskin som värmer belägget till en hög temperatur och fyller
                                    hålen med flytande svart P-tex. Materialet är nästan lika hårt som beläggen och reparationen
                                    räknas som semi-permanenta.
                                </p>
                                <p className="service-price">Pris alpint: 600 sek</p>
                            </article>
                            <article className="serviceLevel-tile">
                                <img className="logo-element" src={Snowflake} alt="snowflake" />
                                <h3 className="service-h3">Bedömning</h3>
                                <p className="service-p">
                                    Är du osäker på vad som behöver göras eller har en större skada kan du ta med utrustningen så
                                    gör vi en bedömning på plats. Du kan lämna utrustningen direkt.
                                </p>
                            </article>
                            
                        </section>
                        <article>
                            <p className="service-p">
                                Vi på Alpine Sport är stolta över att kunna erbjuda professionell skidservice av högsta kvalité och med
                                de bästa produkterna. Samtidigt är vi högst miljömedvetna, därför använder vi bara flourfri valla.
                            </p>
                        </article>
                    </section>

                    <section className="service-section service-rightSection">
                        <article>
                            <h2 className="form-h2">Boka Skidservice</h2>
                            <p className="service-p">
                                För att boka service kan du ringa 0768000202 eller fylla ut frågeformuläret nedan. Ange utrustningstyp och servicenivå så ordnar vi om en tid för inlämning tillsammans. Om du är osäker på vad som behöver göras, välj
                                alternativet &quot;bedömning&quot; så gör vi en bedömning och lämnar ett kostnadsförslag.
                            </p>
                        </article>
                        <BookingForm />
                    </section>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ServicePage;